import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { customerApi } from "@/lib/customerApi";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  // null = checking, false = unauthenticated, object = authenticated
  const [customer, setCustomer] = useState(null);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await customerApi.get("/account/me");
      setCustomer(data);
    } catch (e) {
      setCustomer(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = useCallback(async (email, password) => {
    const { data } = await customerApi.post("/account/login", { email, password });
    setCustomer(data.customer);
    return data.customer;
  }, []);

  const register = useCallback(async (payload) => {
    const { data } = await customerApi.post("/account/register", payload);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await customerApi.post("/account/logout");
      setCustomer(false);
      return true;
    } catch (error) {
      toast.error(formatApiError(error, 'Could not sign out. Please try again.'));
      return false;
    }
  }, []);

  const value = useMemo(
    () => ({ customer, login, register, logout, reload: loadMe }),
    [customer, login, register, logout, loadMe]
  );

  return <CustomerAuthContext.Provider value={value}>{children}</CustomerAuthContext.Provider>;
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
